import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

// mui components
import { Stack } from "@mui/material";


// custom components
import Heading3 from "../../typography/heading-03";
import PrimaryButton from "../../buttons/primary-button";
import LoanParametersSummaryCard from "../loan-parameters-summary";
import LockParametersCard from "../lock-parameter";
import ReLockLoanPricingCard from "../relock-loan-pricing";

// api services
import { useFieldMutation } from "../../../features/field-values/fieldValueApiSlice";

// helper functions
import { filterValue } from "../../../utils/filter-value";

// redux slices
import { selectUserDetails } from "../../../features/auth/authSlice";
import { selectImpersonatedUser } from "../../../features/admin/impersonated-user/impersonatedUserSlice";

// custom styles
import styles from "./index.module.scss";


const ReLockRequestCard = ({
	loanData,
	handleTabChange,
	getFieldValuesOnLoanSummary,
	lockRequestedOn,
	lockStatus,
	goToDefaultView
}) => {
	const ReLockLoanPricingCardRef = useRef(null);
	const [field] = useFieldMutation();

	const userDetails = useSelector(selectUserDetails);
	const impersonatedUser = useSelector(selectImpersonatedUser);

	const [fieldValues, setFieldValues] = useState([]);
	const [isPriceLoanDisabled, setIsPriceLoanDisabled] = useState(true);
	const [obEntityID, setOBEntityID] = useState("");
	const [obUserID, setOBUserID] = useState("");
	const [obLoanID, setOBLoanID] = useState("");

	const handlePriceLoan = async () => {
		if (ReLockLoanPricingCardRef?.current) {
			console.log("Counting",ReLockLoanPricingCardRef?.current);
			ReLockLoanPricingCardRef?.current.handleSubmitApplication();
		}
	};

	const getFieldValues = async () => {
		console.log(
			"LockExtensionRequestCard:getFieldValues:encompassId, loanNumber",
			loanData?.encompassId,
			loanData?.loanNumber
		);

		try {
			const getValues = await field({
				loan_guid: loanData?.encompassId,
				fields:
					"1401,19,VASUMM.X23,1811,1041,356,136,1109,353,976,1540,742,CX.DEBTSERVICECOVERAGERATIO,CX.AUTODEBIT,1550,LCP.X1,2089,762,761,CX.OBTIME,2161,2202,2203,2160,LockRequestedOn,CX.OB.ENTITY.ID,CX.OBLOANID",
			}).unwrap();
			console.log(
				"LockExtensionRequestCard:getFieldValues:all fields",
				getValues?.response
			);

			if(getValues?.response?.length > 0){
				setFieldValues(getValues.response);
			
				const entityField = filterValue(getValues.response, "CX.OB.ENTITY.ID");
				if(entityField !== ""){
					const parts = entityField.split(")")[1].trim();
					const [entity, userID] = parts.split("*");
					setOBEntityID(entity);
					setOBUserID(userID);
			
					const loanID = filterValue(getValues.response, "CX.OBLOANID");
					setOBLoanID(loanID);
			
					console.log("Entity:", entity);
					console.log("UserID:", userID);
					console.log("LoanID:", loanID);
				}
			}
		} catch (err) {
			console.log("LockExtensionRequestCard:getFieldValues:error", err);
		}
	};

	useEffect(() => {
		getFieldValues();
	}, []);

	return (
		<Stack direction="column" className={styles.stackContainer}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				className={styles.topContainer}
			>
			<Heading3
					text="Re-Lock Request"
					extraClass={styles.tabTitle}
					fontType="semibold"
				/>
			</Stack>	
			<LoanParametersSummaryCard loanData={loanData} fieldData={fieldValues} />
			<LockParametersCard loanData={loanData} fieldData={fieldValues} lockRequestedOn={lockRequestedOn} lockStatus={lockStatus} />
			
			{/* OB pricing section container */}
			<ReLockLoanPricingCard
				loanData={loanData}
				loanGuid={loanData?.encompassId}
				setIsPriceLoanDisabled={setIsPriceLoanDisabled}
				handleTabChange={handleTabChange}
				getFieldValuesOnLoanSummary={getFieldValuesOnLoanSummary}
				ref={ReLockLoanPricingCardRef}
				obLoanID={obLoanID}
				obEntityID={obEntityID}
				obUserID={obUserID}
				goToDefaultView={goToDefaultView}
			/>

				<Stack
					direction="row"
					alignItems="center"
					justifyContent="center"
					className={styles.topBtnContainer}
				>
					<PrimaryButton
						text="Submit Request"
						onClick={handlePriceLoan}
						disabled={
							isPriceLoanDisabled ||
							userDetails?.user_roles?.includes("manager") ||
							userDetails?.user_roles?.includes("AM") ||
							userDetails?.user_roles?.includes("executive") ||
							userDetails?.user_roles?.includes("AE") ||
							userDetails?.user_roles?.includes("PA") ||
							userDetails?.user_roles?.includes("assistant") ||
							(userDetails?.user_roles?.includes("admin") === true &&
								impersonatedUser?.email !== null &&
								impersonatedUser?.email !== undefined &&
								impersonatedUser?.email !== "" &&
								(impersonatedUser?.user_roles?.includes("manager") ||
									impersonatedUser?.user_roles?.includes("AM") ||
									impersonatedUser?.user_roles?.includes("executive") ||
									impersonatedUser?.user_roles?.includes("AE") ||
									impersonatedUser?.user_roles?.includes("PA") ||
									impersonatedUser?.user_roles?.includes("assistant")))
						}
					/>
				</Stack>
		</Stack>
	);
};

export default ReLockRequestCard;
